import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import { ifDesktopWindow, ifMobile, isolateMixin } from '../utils/mixins';

var styles = function styles(theme) {
  return _extends({
    root: _extends({
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      fontSize: theme.formGroup.fontSize,
      lineHeight: theme.formGroup.lineHeight + 'px'
    }, ifMobile({
      fontSize: theme.formGroup.mobile.fontSize,
      lineHeight: theme.formGroup.mobile.lineHeight + 'px'
    })),
    normal: {
      marginBottom: theme.formGroup.mobile.marginBottom
    },
    inline: {
      marginBottom: 15
    },
    label: _extends({
      width: '100%',
      display: 'inline-block',
      marginBottom: 10,
      fontWeight: theme.formGroup.label.fontWeight,
      letterSpacing: theme.formGroup.label.letterSpacing
    }, ifMobile({
      fontWeight: theme.formGroup.label.mobile.fontWeight
    })),
    inner: {
      position: 'relative'
    },
    small: {},
    medium: {}
  }, ifDesktopWindow({
    normal: {
      '& $label': {
        width: '100%'
      },
      marginBottom: theme.formGroup.marginBottom
    },
    inline: {
      marginBottom: 30,
      display: 'flex',
      alignItems: 'flex-start',
      '& $label': {
        marginLeft: 0,
        marginBottom: 0,
        maxWidth: 172,
        lineHeight: 1
      },
      '& $inner': {
        flex: 1,
        width: 'auto'
      }
    },
    label: {},
    inner: {
      display: 'inline-block',
      verticalAlign: 'top',
      width: '100%',
      marginLeft: 0
    },
    small: {
      '&$inline $label': {
        paddingTop: 12
      }
    },
    medium: {
      '&$inline $label': {
        paddingTop: 15
      }
    }
  }));
};

var FormGroup = /*#__PURE__*/function (_Component) {
  _inherits(FormGroup, _Component);

  var _super = _createSuper(FormGroup);

  function FormGroup() {
    _classCallCheck(this, FormGroup);

    return _super.apply(this, arguments);
  }

  _createClass(FormGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          inline = _this$props.inline,
          fieldId = _this$props.fieldId,
          className = _this$props.className,
          children = _this$props.children,
          size = _this$props.size,
          classes = _this$props.classes,
          props = _objectWithoutProperties(_this$props, ["label", "inline", "fieldId", "className", "children", "size", "classes"]);

      var rootClass = inline === true ? 'inline' : 'normal';
      var rootClassName = classnames(classes[size], classes[rootClass], classes.root, className);
      var labelClassName = classes.label;
      var innerClassName = classes.inner;
      return React.createElement("section", _extends({
        className: rootClassName
      }, props), label && React.createElement("label", {
        htmlFor: fieldId,
        className: labelClassName
      }, label), React.createElement("div", {
        className: innerClassName
      }, children));
    }
  }]);

  return FormGroup;
}(Component);

FormGroup.defaultProps = {
  size: 'medium'
};
FormGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Задаём стиль FormGroup - в строчку или колонку (label + input).
   * В теме чемпа не используется
   */
  inline: PropTypes.bool,

  /**
   * Указываем label для FormGroup
   */
  label: PropTypes.node,

  /**
   * Размер
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Имя класса - className для FormGroup
   */
  className: PropTypes.string,

  /**
   * Значение для htmlFor in label
   */
  fieldId: PropTypes.string,

  /**
   * Children - может быть FieldStatus или Input.
   */
  children: PropTypes.node.isRequired,

  /**
   * Style - объект со стилями
   */
  style: PropTypes.object
} : {};
export default withStyles(styles, {
  name: 'FormGroup'
})(FormGroup);